module.exports = __webpack_public_path__ + "static/assets/2371ba964a0ebeba1f460ad61fd04cd8.gif";